import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination';
import img from '../images/0.gif'
import img1 from '../images/1.gif';
import img2 from '../images/2.gif';
import img3 from '../images/3.gif';
import img4 from '../images/4.gif';
import img5 from '../images/5.gif';
import icon from '../images/icon-8.svg';
import gif from '../images/play.gif';
import video from '../images/video.mp4';
import video1 from '../images/video-1.mp4';
import video2 from '../images/video-2.mp4';
import video3 from '../images/video-3.mp4';
import video4 from '../images/video-4.mp4';
import video5 from '../images/video-5.mp4';
import { VideoView } from './VideoView';
import { useRef, useState } from 'react';

export const WorkAchievments = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef(null);

    const slides = [
        {
            left: {
                numbers: "10M",
                data: "Views Gained"
            },
            right: {
                numbers: "25K",
                data: "Followers Gained"
            },
            image: img2,
            video: video2,
            play: false
        },
        {
            left: {
                numbers: "10k",
                data: "Views Gained"
            },
            right: {
                numbers: "500",
                data: "Leads Generated"
            },
            image: img1,
            video: video1,
            play: false
        },
        {
            left: {
                numbers: "500K",
                data: "Views Gained"
            },
            right: {
                numbers: "30K",
                data: "Saves Shares"
            },
            image: img,
            video: video,
            play: false
        },
        {
            left: {
                numbers: "2.3K",
                data: "Leads Generated"
            },
            right: {
                numbers: "10K",
                data: "Saves Shares"
            },
            image: img3,
            video: video3,
            play: false
        },
        {
            left: {
                numbers: "480K",
                data: "Views Gained"
            },
            right: {
                numbers: "15K",
                data: "Saves Shares"
            },
            image: img4,
            video: video4,
            play: false
        },
        {
            left: {
                numbers: "3.3M",
                data: "Views Gained"
            },
            right: {
                numbers: "26K",
                data: "Comments Leads"
            },
            image: img5,
            video: video5,
            play: false
        }
    ];

    const handleSlideClick = (index) => {
        if (!swiperRef.current) return;

        if (index === activeIndex) return;

        // If looping is enabled, Swiper uses duplicate slides
        // This ensures the correct index is set
        if (swiperRef.current.params.loop) {
            swiperRef.current.slideToLoop(index);
        } else {
            swiperRef.current.slideTo(index);
        }
    };

    return (
        <div className='work-achievments'>
            <div className="icon-8">
                <img src={icon} alt="" />
            </div>
            <div className="container">
                <h3>Content That <span>Converts</span></h3>
                <p className={'title'}>
                    These creatives showcase high-performing editing styles that have helped our clients gain followers, boost engagement, and generate leads.
                </p>

                <div className='slider-work'>
                    <Swiper
                        slidesPerView={3}
                        spaceBetween={20}
                        loop={true}
                        breakpoints={{
                            200: {
                                slidesPerView: 1.3,
                                spaceBetween: 30,
                                centeredSlides: true
                            },
                            500: {
                                slidesPerView: 1.3,
                                spaceBetween: 30,
                                centeredSlides: true
                            },
                            700: {
                                slidesPerView: 1
                            },
                            810: {
                                slidesPerView: 3,
                            }
                        }}
                        centeredSlides={true}
                        navigation={{ prevEl: '.our-work-prev', nextEl: '.our-work-next', }}
                        modules={[Navigation]}
                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                    >
                        {slides.map((ele, ind) => <SwiperSlide key={ind} onClick={() => handleSlideClick(ind)}>
                            <VideoView video={ele.video} isActive={ind === activeIndex} image={ele.image} left={ele.left} right={ele.right} />
                        </SwiperSlide>)}
                    </Swiper>
                    <div className="swiper-button-prev prev our-work-prev"></div>
                    <div className="swiper-button-next next our-work-next"></div>
                </div>
            </div>
        </div >
    )
}
